import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const cartCreation = async (payload) => {
  try {
    console.log(payload, 'nice payload' )
    const response = await APIs.post(`/create_cart`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getCart = async () => {
  try {
    const response = await APIs.get(`/get_all_cart`, { params: {}, silent: true });

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    return null;
  }
};


const getSingleCart = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_cart/${payload?.Id}`);

    console.log(response?.data, 'nice acting');

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const clearCart = async (payload) => {
  try {
    const response = await APIs.post(`/delete_cart`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const removeCart = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_cart/${payload?.cartId}`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const checkout = async (payload) => {
  try {
    const response = await APIs.post(`/checkout`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const cartServices = {
  cartCreation,
  getCart,
  getSingleCart,
  clearCart,
  removeCart,
  checkout,
};

export default cartServices;
